// extracted by mini-css-extract-plugin
module.exports = {"modal":"_5D1L-c1d","is-open":"_5D1K1eMj","card":"_5D1sr-ZY","is-full-height":"_5D2-ejcp","close":"_5DOBigEo","main":"_5D3FF3if"};